import { render, staticRenderFns } from "./chromePlugin.vue?vue&type=template&id=165d5a8a&"
import script from "./chromePlugin.vue?vue&type=script&lang=js&"
export * from "./chromePlugin.vue?vue&type=script&lang=js&"
import style0 from "./chromePlugin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports